export default __webpack_public_path__ + "static/images/502758f8e42c9e3800ddf6cb0e7e6706.png";